export interface ModerationReport {
  id: string;
  report_type: string;
  category: string;
  reported_user_id: string;
  reporter_user_id: string;
  event_id: string | null;
  reason: string;
  evidence: Record<string, any>;
  status: string;
  severity: string;
  admin_notes: string | null;
  action_taken: string | null;
  reviewed_by: string | null;
  reviewed_at: string | null;
  created_at: string;
  reported_display_name: string | null;
  reported_username: string | null;
  reported_email: string | null;
  reporter_display_name: string | null;
  reporter_username: string | null;
  event_title: string | null;
  total_reports_against_user: number;
}

export interface ModerationStats {
  pending_reports: number;
  under_review: number;
  actioned_this_week: number;
  dismissed_this_week: number;
  total_reports: number;
  by_type: Record<string, number>;
  by_severity: Record<string, number>;
  chat_reports_pending: number;
  chat_bans_active: number;
  users_currently_suspended: number;
  repeat_offenders: number;
}

export interface UserRiskProfile {
  content_reports: number;
  content_reports_pending: number;
  chat_message_reports: number;
  chat_bans: number;
  no_shows: number;
  blocks_received: number;
  is_suspended: boolean;
  suspended_until: string | null;
  report_categories: Record<string, number>;
  recent_reports: Array<{
    id: string;
    report_type: string;
    category: string;
    reason: string;
    severity: string;
    status: string;
    created_at: string;
    reporter_name: string | null;
  }>;
}

export const SEVERITY_CONFIG: Record<string, { color: string; bg: string; label: string }> = {
  critical: { color: '#ef4444', bg: 'rgba(239,68,68,0.15)', label: 'CRITICAL' },
  high: { color: '#f59e0b', bg: 'rgba(245,158,11,0.15)', label: 'HIGH' },
  medium: { color: '#3b82f6', bg: 'rgba(59,130,246,0.15)', label: 'MEDIUM' },
  low: { color: '#6b7280', bg: 'rgba(107,114,128,0.15)', label: 'LOW' },
};

export const TYPE_LABELS: Record<string, string> = {
  user_profile: 'Profile Report',
  chat_message: 'Chat Report',
  grouppulse_behavior: 'Ride Behavior',
  event_content: 'Event Content',
  profile_image: 'Profile Image',
};

export const CATEGORY_LABELS: Record<string, string> = {
  spam: 'Spam',
  harassment: 'Harassment',
  inappropriate: 'Inappropriate',
  offensive: 'Offensive',
  unsafe_riding: 'Unsafe Riding',
  location_spoofing: 'Location Spoofing',
  obscenity: 'Obscenity',
  terms_violation: 'Terms Violation',
  other: 'Other',
};

export const STATUS_ACTIONS = [
  { value: 'dismissed', label: 'Dismiss', color: '#6b7280' },
  { value: 'warning_issued', label: 'Warn User', color: '#f59e0b' },
  { value: 'actioned', label: 'Take Action', color: '#ef4444' },
];
